/**
 * Maps a push notification's `data` payload to an in-app route, or null if the
 * notification isn't clickable. Keep in sync with getNotificationUrl in public/sw.js,
 * which can't import this module.
 */
const SPORT_ROUTE_MAP: Record<string, string> = {
  cricket: 'cricket',
  soccer: 'football',
  football: 'football',
  tennis: 'tennis',
};

// Racing events open on /details/:game/:eventId (see RaceRow), keyed by the
// sport name as the backend sends it.
const RACING_SPORTS: Record<string, string> = {
  horseracing: 'HorseRacing',
  greyhound: 'Greyhound',
};

export function getNotificationUrl(data?: Record<string, string>): string | null {
  if (!data) return null;

  if (data.screen === 'event-details' && data.eventId) {
    const sportKey = data.sport?.toLowerCase() ?? '';

    const racingSport = RACING_SPORTS[sportKey];
    if (racingSport) return `/details/${racingSport}/${data.eventId}`;

    const sportRoute = SPORT_ROUTE_MAP[sportKey];
    if (!sportRoute) return null;
    return `/sports/${sportRoute}/market-details/${data.eventId}`;
  }

  // Allow the backend to send an explicit in-app path.
  if (data.url?.startsWith('/')) return data.url;

  return null;
}
